<template>
  <!-- 话务系统-跟进记录 -->
  <div>
    <el-row :gutter="20">
      <el-col :span="16">
        <avue-crud :option="msgOption" :data="msgList" @on-load="loadMsgList"></avue-crud>
      </el-col>
      <el-col :span="8">
        <avue-crud :option="orderOption" :data="orderList" @on-load="loadOrderList">
          <template slot="orderNo" slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              v-for="orderCode in row.orderNo.split(',')"
              :key="orderCode"
              @click="showOrderDetail(orderCode)"
            >
              {{ orderCode.split('-')[0] }}
            </el-button>
          </template>
        </avue-crud>
      </el-col>
    </el-row>
    <div class="records" v-if="listData.length > 0">
      <div class="top">
        <div>跟进记录</div>
        <div @click="() => (isCollapsed = !isCollapsed)">{{ isCollapsed ? '展开' : '收起' }}</div>
      </div>
      <div class="content" v-if="!isCollapsed">
        <div class="left">
          <div class="item" v-for="item in listData" :key="item.id" @click="getDetail(item)">
            <span>{{ item.callStartTime }}</span>
            <span>{{ item.callType == 2 ? '呼出' : '呼入' }}</span>
          </div>
        </div>
        <div class="right" v-if="detailData">
          <div class="sub-title">详情</div>
          <div class="detail">
            <el-form>
              <el-row>
                <el-col span="8">
                  <el-form-item label="主叫号码：">
                    {{ detailData.fromPhone }}
                  </el-form-item>
                </el-col>
                <el-col span="8">
                  <el-form-item label="被叫号码：">
                    {{ detailData.toPhone }}
                  </el-form-item>
                </el-col>
                <el-col span="8">
                  <el-form-item label="振铃时长：">
                    {{ (detailData.callRingDuration || 0) + '秒' }}
                  </el-form-item>
                </el-col>
                <el-col span="8">
                  <el-form-item label="通话时长：">
                    {{ secondsToDuration(detailData.callDuration) }}
                  </el-form-item>
                </el-col>
                <el-col span="8">
                  <el-form-item label="开始时间：">
                    {{ detailData.callStartTime }}
                  </el-form-item>
                </el-col>
                <el-col span="8">
                  <el-form-item label="结束时间：">{{ detailData.callEndTime }}</el-form-item>
                </el-col>
                <el-col span="8">
                  <el-form-item label="坐席工号：">{{ detailData.serviceNo }}</el-form-item>
                </el-col>
                <el-col span="16">
                  <el-form-item label="关联工单：">
                    <el-button
                      type="text"
                      size="small"
                      v-for="orderCode in detailData.orderNo.split(',')"
                      :key="orderCode"
                      @click="showOrderDetail(orderCode)"
                    >
                      {{ orderCode.split('-')[0] }}
                    </el-button>
                  </el-form-item>
                </el-col>
                <el-col span="24">
                  <el-form-item label="通话录音：">
                    <AudioBar
                      v-if="detailData.audioUrl"
                      :audioInfo="{ audioUrl: detailData.audioUrl }"
                    ></AudioBar>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioBar from '../components/audio-bar';
import { secondsToDuration } from '../common';
import {
  getRecordsApi,
  getRecordDetailApi,
  getMsgListApi,
  getOrderListApi,
} from '@/api/call-system/call-sidebar';

export default {
  name: 'CallRecords',
  props: {
    /* 客户号码 */
    phoneNum: {
      type: String,
    },
  },
  components: {
    AudioBar,
  },
  data() {
    return {
      isCollapsed: false, // 是否折叠着
      listData: [], // 列表数据
      detailData: null, // 详情数据
      msgList: [], // 有内容记录的记录列表
      orderList: [], // 有关联工单的记录列表
      msgOption: {
        height: '200px',
        calcHeight: 0,
        border: true,
        addBtn: false,
        menu: false,
        column: [
          {
            label: '记录时间',
            prop: 'callStartTime',
            width: 160,
          },
          {
            label: '内容记录',
            prop: 'description',
            overHidden: true,
          },
        ],
      },
      orderOption: {
        height: '200px',
        calcHeight: 0,
        border: true,
        addBtn: false,
        menu: false,
        column: [
          {
            label: '记录时间',
            prop: 'callStartTime',
            width: 160,
          },
          {
            label: '关联工单',
            prop: 'orderNo',
            slot: true,
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    secondsToDuration: secondsToDuration,
    loadMsgList() {
      getMsgListApi({
        customerTel: this.phoneNum,
      }).then(({ data }) => {
        this.msgList = data;
      });
    },
    loadOrderList() {
      getOrderListApi({
        customerTel: this.phoneNum,
      }).then(({ data }) => {
        this.orderList = data;
      });
    },
    getList() {
      getRecordsApi({
        customerTel: this.phoneNum,
      }).then(({ data }) => {
        this.listData = data;
      });
    },
    getDetail(item) {
      getRecordDetailApi({
        id: item.id,
      }).then(({ data }) => {
        this.detailData = data;
      });
    },
    /* 查看工单详情 */
    showOrderDetail(orderCode) {
      this.$emit('showOrderDetail', { orderCode });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
/* 去掉表格下方的分页区域 */
::v-deep .avue-crud__pagination {
  display: none !important;
}
/* 表格宽度100% */
::v-deep .avue-crud {
  width: 100% !important;
}

.records {
  border: solid 1px #dcdfe6;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;

  .top {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;

    :nth-child(1) {
      font-weight: bold;
    }
    :nth-child(2) {
      cursor: pointer;
      color: #409eff;
    }
  }

  .content {
    width: 100%;
    height: 170px;
    display: flex;

    .left {
      width: 220px;
      height: 100%;
      padding: 0 5px;
      box-sizing: border-box;
      border: solid 1px #dcdfe6;
      overflow-y: scroll;
      margin-right: 30px;

      .item {
        cursor: pointer;
        display: flex;
        width: 100%;
        height: 30px;
        align-items: center;
        justify-content: space-between;
      }
    }

    .right {
      flex: 1;
      overflow-x: hidden;
      display: flex;

      .sub-title {
        width: 100px;
      }

      .detail {
        flex: 1;
        overflow-x: hidden;
      }
    }
  }
}
</style>
